import Button from "component/Button";
import React, { Fragment, useState } from "react";
import { Home } from "react-feather";
import { Link, useNavigate } from "react-router-dom";
import strings from "translate/language";
// import Bookmark from './bookmark';

const Breadcrumb = (props) => {
  const {
    title,
    url,
    parentListing,
    titleactive,
    backurl = -1,
    isBackBtn = false,
  } = props;
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  return (
    <Fragment>
      <div className="container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col-md-10">
              <div className="page-header-left">
                <h3>{title}</h3>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a>
                      <i
                        className="fa fa-home theme-fa-icon"
                        aria-hidden="true"
                        onClick={() => navigatpage("/dashboard")}
                      ></i>
                    </a>
                  </li>
                  {parentListing && (
                    <li
                      className="breadcrumb-item"
                      onClick={() => {
                        navigatpage(url);
                      }}
                    >
                      {parentListing}
                    </li>
                  )}
                  <li className="breadcrumb-item active">{titleactive}</li>
                  {/* </li> */}
                </ol>
              </div>
            </div>
            {/* <div className="row"> */}
            {isBackBtn && (
              <div className="col-md-2 d-flex justify-content-end">
                <Button
                  className="btn btn-color"
                  onClick={() => {
                    navigatpage(backurl);
                  }}
                  label={strings.back}
                ></Button>
              </div>
            )}
            {/* </div> */}
            {/* <!-- Bookmark Start--> */}
            {/* <Bookmark /> */}
            {/* <!-- Bookmark Ends--> */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Breadcrumb;
